import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  StyledAutocomplete,
  Item,
  Highlight,
  Superscript
} from './Autocomplete.styles'

const getHighlightText = (term, text) => {
  const textLowerCase = text.toLowerCase()
  const termLowerCase = term.toLowerCase()
  const termPosition = textLowerCase.indexOf(termLowerCase)

  if (termPosition > -1) {
    const textBefore = text.substring(0, termPosition)
    const textAfter = text.substring(termPosition + term.length, text.length)
    const termInText = text.substring(termPosition, termPosition + term.length)

    return (
      <Fragment>
        {textBefore}
        <Highlight>{termInText}</Highlight>
        {textAfter}
      </Fragment>
    )
  }

  return text
}

const Autocomplete = ({ data, onClickItem, visible, term, ...rest }) => (
  <StyledAutocomplete visible={visible} {...rest}>
    {data.map((item, index) => (
      <Item key={index} onClick={() => onClickItem(item)}>
        {item?.superscript && <Superscript>{item.superscript}</Superscript>}
        {term
          ? getHighlightText(term, item?.name || item?.title)
          : item?.name || item?.title}
      </Item>
    ))}
  </StyledAutocomplete>
)

Autocomplete.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string,
      type: PropTypes.string,
      cid: PropTypes.string, // only for publications
      id: PropTypes.number // for entities and readers
    })
  ).isRequired,
  term: PropTypes.string, // the term is used to highlight a part of the text
  onClickItem: PropTypes.func.isRequired
}

Autocomplete.defaultProps = {
  data: [],
  visible: false
}

export default Autocomplete
